import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

productDescriptionStyles.productDetailLink = {
    css: css`
        width: 100%;
        span {
            font-family: ${getProp("theme.typography.h6.fontFamily")};
            font-weight: 700;
            ${wrapInContainerStyles};
        }
    `,
    typographyProps: {
        variant: "h6",
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
        `,
    },
};
